import FadeIn from "../Animations/FadeIn"
import OurPartnerContractors from "./OurPartnerContractors"

const OurPartners = ({ ourPartners }) => {
    return (
        <div className="our-partners" id="our-partners">
            <FadeIn customClass="header-section">
                <h5 className="light _eleX">{ourPartners?.header}</h5>
                <p className="_eleX">{ourPartners?.description}</p>
            </FadeIn>
            {ourPartners?.Consultants &&
                <div className="contractors-section">
                    <OurPartnerContractors title={ourPartners?.Consultants_header} contractors={ourPartners?.Consultants} />
                </div>
            }
            {ourPartners?.Contractors &&
                <div className="contractors-section">
                    <OurPartnerContractors title={ourPartners?.contractors_header} contractors={ourPartners?.Contractors} />
                </div>
            }
            {ourPartners?.Designers &&
                <div className="contractors-section">
                    <OurPartnerContractors title={ourPartners?.Designers_header} contractors={ourPartners?.Designers} />
                </div>
            }
        </div>
    )
}

export default OurPartners